import styled from "@emotion/styled";
import { HelpRequestStatus } from "../types/summaryStateStypes";

export const Columns = styled.div({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
});

export const Rows = styled.div({
  display: "flex",
  alignItems: "center",
});

export const PageTitle = styled.div({
  fontSize: 24,
  textAlign: "center",
});

export const caseTimeStatusHeaderText = (
  actionStatus: HelpRequestStatus,
  secondsSince?: number
) => {
  if (!secondsSince) return undefined;

  if (actionStatus == "COMPLETE") {
    return "CASE CLOSED";
  }

  let statusText;
  statusText = "Open for ";

  if (secondsSince < 60) return `${statusText} ${secondsSince}s`;

  let mins = Math.floor(secondsSince / 60);
  let hours = Math.floor(mins / 60);
  let days = Math.floor(hours / 24);

  if (mins < 60) {
    return `${statusText} ${mins}m ${secondsSince % 60}s`;
  }

  if (hours < 24) {
    return `${statusText} ${hours}h ${mins % 60}m`;
  }

  return `${statusText} ${days}d ${hours % 24}h`;
};

export const secondsSinceToTimestamp = (secondsSince?: number) => {
  if (!secondsSince || secondsSince == 0) return "N/A";

  if (secondsSince < 60) return `${secondsSince}s`;

  let mins = Math.floor(secondsSince / 60);
  let hours = Math.floor(mins / 60);
  let days = Math.floor(hours / 24);

  if (mins < 60) return `${mins}m ${secondsSince % 60}s`;

  if (hours < 24) return `${hours}h ${mins % 60}m`;

  return `${days}d ${hours % 24}h`;
};
